<template>
    <div class="section">
        <b-loading :active.sync="loading" :if-full-page="false"></b-loading>
        <div class="columns is-multiline">
            <div v-for="order in orders" :key="order.id" class="column is-half m-b-20">
                <div class="card">
                    <div class="card-content">
                        <p class="has-text-wight-bold is-size-3">Orden id: {{order.id}} - <span class="has-text-info">{{order.getStatusDisplay}}</span>   </p>
                        <p><b>Monto en UY:</b> UY$ {{order.payment.amountUy}}</p>
                        <p><b>Monto en USD:</b> U$D {{order.payment.amountUsd}}</p>
                        <p><b>Pagas usando:</b> {{order.payment.getMethodDisplay}}</p>
                        <p><b>Metodo de envio:</b> {{order.orderdata.getShipmentMethodDisplay}}</p>
                        <p><b>Tu direccion:</b>  {{order.orderdata.address}} - {{order.orderdata.number}}. {{order.orderdata.location}}, {{order.orderdata.region}} - {{order.orderdata.zipCode}}</p>
                    </div>
                    <div class="has-text-centered m-b-10 m-t-10 p-b-10">
                        <b-button
                        type="is-info"
                        rounded
                        @click="selectOrder(order)">
                            <b-icon icon="eye" class="m-r-5" size="is-small"></b-icon> 
                            Ver detalle
                        </b-button>
                        <a
                        :href="order.getPendingPaymentUrl"
                        class="m-l-5 button is-success is-rounded"
                        >
                            <b-icon icon="info-circle" class="m-r-5" size="is-small"></b-icon>
                            Info de estado
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="!orders.length" class="column is-full has-text-centered">
                <img width="400px" src="https://traction-prod.ams3.digitaloceanspaces.com/static/assets/img/nothing_here.png" alt="">
                <p class="is-size-3 title">Parece que todavia no compraste nada...</p>
            </div>
        </div>

        <div v-if="!orders.length" class="m-top-30">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="emitOnPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>

        <b-modal :active.sync="detailModal" scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">
                <div class="modal-card-body">
                    
                    <div class="container" v-if="selectedOrder && cartToDetail">
                        <b-table
                        :loading="loadingCart"
                        :data="cartToDetail.items"
                        :hoverable="true">
                            <template slot-scope="props">
                                <b-table-column label="Producto">
                                    {{ props.row.productTitle }}
                                </b-table-column>
                                <b-table-column label="Variantes">
                                    <span v-for="val in props.row.valueNames" :key="val">
                                        {{val}}, 
                                    </span>
                                </b-table-column>
                                <b-table-column label="Cantidad">
                                    {{ props.row.quantity }}
                                </b-table-column>
                                <b-table-column label="Precio unidad">
                                    {{ props.row.unitPrice }}
                                </b-table-column>
                                <b-table-column label="Total uy">
                                    {{ props.row.totalInUy }}
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>

                </div>
            </div>
        </b-modal>


    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        orders:{
            type:Array,
            default:new Array([])
        },
        loading:{
            type:Boolean,
            default:false
        },
        count:{
            type:Number,
            default:0
        },
        page:{
            type:Number,
            default:0
        },
        perPage:{
            type:Number,
            default:24
        },
        cartUrl:{
            type:String,
            default:""
        }
    },

    data(){
        return{
            detailModal:false,
            selectedOrder:{},
            cartToDetail:{},
            loadingCart:false,
        }
    },

    methods:{
        emitOnPageChange(page){
            this.$emit("pageChanged", page)
        },

        async selectOrder(order){
            this.detailModal = true
            this.selectedOrder=order
            let url = this.cartUrl.replace("0000", order.cart)
            this.loadingCart = true
            this.cartToDetail = await getHandler(url, {error:false, success:false})
            console.log(this.cartToDetail)
            this.loadingCart = false
        }
    }
}
</script>

<style lang="scss" scoped>
.card{
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 10px 10px rgba(184, 184, 184, 0.55);
}
</style>